import { Tween, Easing } from '@tweenjs/tween.js';
import { COMPONENTS, EVENTS } from '../../lib/constants';
import { GameConfigs } from '../../lib/globals/GameConfigs';
import { getCurrencySymbol } from '../helper/currencies';
import { TextMetrics } from 'pixi.js';
// import QuestData from "./helper/getQuestData";
import HELPERS from '../../lib/globals/helpers/Helpers';
import { QuestPromptView } from '../../view/quest/QuestPromptView';
import AnimateEntrance from '../helper/animate';

class QuestStatusBarController {
	constructor(vc, conf) {
		this.config = conf;
		this.vc = vc;
		window.addEventListener(EVENTS.REEL_FINISHED, this, false);
		window.addEventListener(EVENTS.ERROR_MSG, this, false);
		window.addEventListener(EVENTS.BONUS_BUY, this, false);
		window.addEventListener(EVENTS.BET_PLACED, this, false);
		window.addEventListener(EVENTS.MODAL, this, false);
		window.addEventListener(EVENTS.WIN_HIGHLIGHT, this, false);
		window.addEventListener(EVENTS.QUEST_END, this, false);
		AnimateEntrance(this.vc);
		this.total = GameConfigs.quest_current ? GameConfigs.quest_current.win : 0;
		this.win_text = 0;
		this.win_modal = false;
		if (GameConfigs.quest_current) {
			this.leftSpins =
				GameConfigs.quest_current.prize.count -
				GameConfigs.quest_current.claimed;
		} else {
			this.leftSpins = GameConfigs.quest_claim.item.prize.count;
		}
		this.currency = getCurrencySymbol(GameConfigs.auth.balance.currency);
		this.updateWin(this.total);
		this.init();
	}

	init() {
		this.vc.bg.texts.FREE_SPIN_LEFT_AMOUNT.text = this.leftSpins;
		this.setWin(this.total);
		if (GameConfigs.quest_claim.item.prize.type === 'wild_respin') {
			this.vc.bg.texts.FREE_SPIN_LEFT.text = 'WILD SPINS LEFT';
			const FREE_SPIN_LEFT = TextMetrics.measureText(
				this.vc.bg.texts.FREE_SPIN_LEFT.text,
				this.vc.bg.texts.FREE_SPIN_LEFT.style
			);
			this.vc.bg.texts.FREE_SPIN_LEFT_AMOUNT.position.x =
				this.vc.bg.texts.FREE_SPIN_LEFT.position.x + FREE_SPIN_LEFT.width + 10;
		}
		if (GameConfigs.quest_claim.item.prize.type === 'bet_discount') {
			this.vc.bg.texts.FREE_SPIN_LEFT.text = 'BETS LEFT';
			const FREE_SPIN_LEFT = TextMetrics.measureText(
				this.vc.bg.texts.FREE_SPIN_LEFT.text,
				this.vc.bg.texts.FREE_SPIN_LEFT.style
			);
			this.vc.bg.texts.FREE_SPIN_LEFT_AMOUNT.position.x =
				this.vc.bg.texts.FREE_SPIN_LEFT.position.x + FREE_SPIN_LEFT.width + 10;
		}
		if (GameConfigs.quest_claim.item.prize.type === 'win_multiplier') {
			this.vc.bg.texts.FREE_SPIN_LEFT.text = 'SPINS LEFT';
			const FREE_SPIN_LEFT = TextMetrics.measureText(
				this.vc.bg.texts.FREE_SPIN_LEFT.text,
				this.vc.bg.texts.FREE_SPIN_LEFT.style
			);
			this.vc.bg.texts.FREE_SPIN_LEFT_AMOUNT.position.x =
				this.vc.bg.texts.FREE_SPIN_LEFT.position.x + FREE_SPIN_LEFT.width + 10;
		}
	}

	handleEvent(object) {
		switch (object.type) {
			case EVENTS.REEL_FINISHED:
				this.reelFinished(object);
				break;
			case EVENTS.ERROR_MSG:
				this.removeEventListeners();
				break;
			case EVENTS.QUEST_END:
				this.removeEventListeners();
				break;
			case EVENTS.WIN_HIGHLIGHT:
				if (
					!object.detail.open &&
					GameConfigs.quest_claim.leftBets === 0 &&
					GameConfigs.quest_is_active
				) {
					this.status = 'completed';
					this.showTotalWin();
				}
				break;
			case EVENTS.BONUS_BUY:
				if (object.detail.bonus) {
					this.removeEventListeners();
				}
				break;
			case EVENTS.BET_PLACED:
				if (object.detail.placed) {
					if (
						GameConfigs.quest_claim.activated_item ===
						GameConfigs.quest_claim.pending_item
					) {
						this.leftSpins--;
						this.vc.bg.texts.FREE_SPIN_LEFT_AMOUNT.text = this.leftSpins;
						GameConfigs.quest_claim = {
							...GameConfigs.quest_claim,
							leftBets: this.leftSpins
						};
					}
				}
				break;
			default:
				break;
		}
	}

	reelFinished() {
		this.total = GameConfigs.quest_current.win;
		this.updateWin(this.total);
		if (GameConfigs.quest_is_active && GameConfigs.quest_claim.leftBets === 0) {
			HELPERS.disableAllButtons(true);
			this.resetQuest();
			if (HELPERS.getWinLevels().length > 0) return;
			this.showTotalWin();
		}
	}

	resetQuest() {
		if (GameConfigs.autospin.isAutoOn) {
			HELPERS.dispatchCustomEvent(EVENTS.AUTO_STARTED, {
				numOfBets: GameConfigs.autospin.numOfBets,
				isAutoOn: false,
				leftBets: 0,
				pause: false
			});
		}
		GameConfigs.quest_claim = {
			...GameConfigs.quest_claim,
			activated_item: 0
		};
		// GameConfigs.quest_current = null;
	}
	showTotalWin() {
		if (GameConfigs.uiComponent[COMPONENTS.QUEST_PROMPT] === undefined) {
			HELPERS.dispatchCustomEvent(EVENTS.MODAL, { modal: 'quest_prompt' });
			GameConfigs.uiComponent.addView(QuestPromptView);
		}

		this.removeEventListeners();
	}

	setWin(win) {
		if (this.currency[1] === 'left') {
			this.vc.bg.texts.FREE_SPIN_WIN_AMOUNT.text =
				this.currency[0] +
				(+win).toLocaleString(undefined, {
					minimumFractionDigits: GameConfigs.config.currency_prec,
					maximumFractionDigits: GameConfigs.config.currency_prec
				});
		} else {
			this.vc.bg.texts.FREE_SPIN_WIN_AMOUNT.text =
				(+win).toLocaleString(undefined, {
					minimumFractionDigits: GameConfigs.config.currency_prec,
					maximumFractionDigits: GameConfigs.config.currency_prec
				}) +
				(GameConfigs.auth.balance.currency === 'GEL' ? '' : ' ') +
				this.currency[0];
		}
	}

	updateWin(win) {
		this.tweener = new Tween(this)
			.to({ win_text: win }, 500)
			.easing(Easing.Linear.None)
			.onUpdate(() => {
				this.setWin(this.win_text);
			})
			.start();
	}

	removeEventListeners() {
		window.removeEventListener(EVENTS.REEL_FINISHED, this, false);
		window.removeEventListener(EVENTS.ERROR_MSG, this, false);
		window.removeEventListener(EVENTS.BET_PLACED, this, false);
		window.removeEventListener(EVENTS.MODAL, this, false);
		window.removeEventListener(EVENTS.BONUS_BUY, this, false);
		window.removeEventListener(EVENTS.WIN_HIGHLIGHT, this, false);
		window.removeEventListener(EVENTS.QUEST_END, this, false);
	}
}
export default QuestStatusBarController;
